import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './i18n/config';
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,

  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],

  // Monitoraggio Performance: 10% delle transazioni per risparmiare quota
  tracesSampleRate: 0.1,

  // Replay Sessioni: solo quando avviene un errore (costo zero)
  replaysSessionSampleRate: 0.0,
  replaysOnErrorSampleRate: 1.0,

  // Impedisce l'invio di log durante lo sviluppo locale
  enabled: import.meta.env.PROD,

  // Ignora errori comuni di rete o estensioni browser
  ignoreErrors: [
    'Network Error',
    'Extension context invalidated',
  ],
});

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);